import { combineReducers } from 'redux';

import districtInfo from './districtInfo/reducer';
import householdCategoricalTypes from './householdCategoricalTypes/reducer';
import taxRates from './taxRates/reducer';
import haccp from './haccp/reducer';
import recipeGroup from './recipeGroup/reducer';
import ingredientGroup from './ingredientGroup/reducer';
import cnVersionInformation from './CNVersionInformation/reducer';

export default combineReducers({
  districtInfo,
  householdCategoricalTypes,
  taxRates,
  haccp,
  recipeGroup,
  ingredientGroup,
  cnVersionInformation,
});



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/reducer.js